
export const StatsSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-8">
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">20%</div>
            <p className="text-gray-600 font-medium">Revenue Growth</p>
            <p className="text-sm text-gray-500 mt-1">With AI optimization</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">3x</div>
            <p className="text-gray-600 font-medium">Faster Lead Qualification</p>
            <p className="text-sm text-gray-500 mt-1">AI-powered agents</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">25%</div>
            <p className="text-gray-600 font-medium">Cost Reduction</p>
            <p className="text-sm text-gray-500 mt-1">Automated workflows</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">40%</div>
            <p className="text-gray-600 font-medium">ROAS Improvement</p>
            <p className="text-sm text-gray-500 mt-1">Data-driven campaigns</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-2">15%</div>
            <p className="text-gray-600 font-medium">Sales Growth</p>
            <p className="text-sm text-gray-500 mt-1">In first 90 days</p>
          </div>
        </div>
      </div>
    </section>
  );
};
